module.exports = __webpack_public_path__ + "static/media/6_School of the animals_SO.e22a8318.txt";